import gql from 'graphql-tag';

const query = gql`
  query CookbookMeals($searchCriteria: MealsSearchCriteriaInputType) {
    cookbook {
      meals(searchCriteria: $searchCriteria) {
        edges {
          node {
            id
            isFavorite
            name
            preparationTime {
              minutes
            }
            nutrition {
              singleServing {
                kcal
              }
            }
            preparationImageUrl
            tags {
              dietTypeTags {
                id
                name
              }
              mealTypeTags {
                id
                name
              }
              customTags {
                id
                name
                labelColor
              }
            }
            rating {
              averageRating {
                averageRating
              }
            }
          }
        }
      }
    }
  }
`;

export default query;
